import React from 'react';
import { upperFirst } from 'lodash';
import { compose } from 'recompose';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import PostCtaAction from './components/PostCtaAction';
import Cta from './components/Cta';
import withLoyaltyNotification from '../../hoc/withLoyaltyNotification';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import Money from '../../../components/Money';

/* eslint-disable react/prop-types */
const CustomerLoyaltyInitiation = ({
  shop,
  customer,
  appLink,
  loyaltyAmount,
  loyaltyAmountGoal,
  loyaltyTransactionsGoal,
  isAmountBased,
  squireInfoClassName,
}) => (
  <div>
    <Header
      shopName={shop.name}
      loyaltyAmountGoal={loyaltyAmountGoal}
      loyaltyTransactionsGoal={loyaltyTransactionsGoal}
      isAmountBased={isAmountBased}
      loyaltyAmount={loyaltyAmount}
      customerName={upperFirst(customer.firstName)}
    />
    <NotificationContent>
      <Logo />
      <div className="u-text-normal u-co-grey u-mt-10 u-3/4">
        {shop.name} is now offering a loyalty program for its valued customers.
      </div>
      <h2 className="u-text-huge u-fw-bold u-mt-5 u-mb-20">
        {
          isAmountBased && (
            <span>
              Hey {upperFirst(customer.firstName)}, you&apos;ll receive <Money noDecimalsIfInt>{loyaltyAmount}</Money>
              &nbsp;off once you reach the goal of <Money noDecimalsIfInt>{loyaltyAmountGoal}</Money>.
            </span>
          )
        }
        {
          !isAmountBased && (
            <span>
              Hey {upperFirst(customer.firstName)}, you&apos;ll receive a <Money noDecimalsIfInt>{loyaltyAmount}</Money>
              &nbsp;loyalty reward after {loyaltyTransactionsGoal} transactions.
            </span>
          )
        }
      </h2>
      { shop.mobileAppCta && <Cta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          shopName={shop.name}
          renderAction={PostCtaAction}
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default compose(
  withAppointmentNotification,
  withLoyaltyNotification,
)(CustomerLoyaltyInitiation);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerLoyaltyInitiation/index.jsx